import { render } from "./TheDemandActionButton2.vue?vue&type=template&id=579043e2"
import script from "./TheDemandActionButton2.vue?vue&type=script&lang=js"
export * from "./TheDemandActionButton2.vue?vue&type=script&lang=js"
script.render = render

export default script